// extracted by mini-css-extract-plugin
export default {"avaliableInContainer":"AvaliableIn_avaliableInContainer__qpuZJ"};